<script>
import Editor from '@tinymce/tinymce-vue';
import deepmerge from 'deepmerge';

const EDITOR_OPTIONS = {
  height: 500,
  menubar: false,
  block_formats: 'Paragraph=p; Header 1=h1; Header 2=h2; Header 3=h3; Header 4=h4; Header 5=h5; Header 6=h6',
  plugins: [
    'advlist autolink lists link image charmap print preview anchor textcolor',
    'searchreplace visualblocks fullscreen',
    'insertdatetime media table contextmenu paste help wordcount',
  ],
  toolbar: 'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist | removeformat | help',
};
const API_KEY = 'jol745g2sbve3lxoc4hddsq05oyqzk3hmgrnlvjcxwwbriex';

export default {
  functional: true,
  render (h, ctx) {
    ctx.data.props = ctx.data.props || {};
    ctx.data.props.init = deepmerge(EDITOR_OPTIONS, ctx.props.options || {});
    ctx.data.props.apiKey = API_KEY;

    return h(Editor, ctx.data, ctx.children);
  },
};
</script>
